var check = require('../util/regex-check');
module.exports = check(/[A-Za-z]/);